import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
  const { t } = useTranslation();

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="header-info">
            <h1>{t('header.title')}</h1>
            <p className="subtitle">{t('header.subtitle')}</p>
          </div>
          
          <div className="header-actions">
            <div className="header-links">
              <a 
                href="https://www.linkedin.com/in/henrique-sinhori-pedro-380582182/" 
                target="_blank" 
                rel="noopener noreferrer"
                title="LinkedIn"
              >
                <FaLinkedin size={24} />
              </a>
              <a 
                href="mailto:sinhoripedro@hotmail.com"
                className="header-link-item"
              >
                <FaEnvelope size={20} />
                <span className="link-text">{t('header.support')}</span>
              </a>
            </div>
            
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;